import React, { useContext } from 'react';
import getRoleLabelText from '../utils/getRoleLabelText';
import GlobalContext from '../../../utils/GlobalContext';

export default function CommentRoleLabelComponent({ sender, currentUserId }) {
  const { locales } = useContext(GlobalContext);
  if (sender.id === currentUserId)
    return (
      <div className="comment-item-header-sender__role owner">
        {locales.chatSystem.you}
      </div>
    );

  return (
    <div className="comment-item-header-sender__role">
      {getRoleLabelText(sender.role)}
    </div>
  );
}
